<template>
  <div style="margin-top: 50px;">
    <div class="footer mt-5">
      <v-container>
        <v-row>
          <div class="contact">
            <v-col cols="12">
              <div class="social">
                <div class="img-social d-flex flex-row align-items-center mrx-auto mlx-auto">
                  <img alt="" class="mlx-3" role="button" @click="oracle.openLink('https://www.nanavaran.com')"
                       style="opacity: 0.5" src="https://www.nanavaran.com/icon.png">
                  <img alt="" style="opacity: 0.5" :src="require('@/assets/image/halal.png')">
                  <img alt="" style="opacity: 0.5" :src="require('@/assets/image/vegan.png')">
                  <a referrerpolicy="origin" target="_blank"
                     href="https://trustseal.enamad.ir/?id=127510&amp;Code=wlDPRmk2laScuSIKlodx">
                    <div class="d-flex flex-column" style="max-width: 100px; max-height: 100px">
                      <img loading="lazy" width="100" height="100"
                           :alt="oracle.translate('نماد اعتماد الکترونیک')"
                           referrerpolicy="origin"
                           src="https://Trustseal.eNamad.ir/logo.aspx?id=127510&amp;Code=wlDPRmk2laScuSIKlodx"
                           style="cursor:pointer" id="wlDPRmk2laScuSIKlodx"/>
                    </div>
                  </a>
                </div>
                <div class="item-social">
                </div>
              </div>
            </v-col>
          </div>
        </v-row>
        <div class="end-footer d-flex flex-row justify-space-between">
                <span class="mt-3">All Rights Reserved For <b>Cluna Group</b></span>
          <div class="d-flex flex-row mrx-auto" style="width: fit-content">
            <div v-for="(item, index) in socials" :key="index">
              <img alt="" role="button" @click="oracle.openLink(item.social_url)" :src="item.social_avatar"
                   style="width: 50px; height: 50px; transform: scale(0.6)" class="center-cropped"/>
            </div>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>
<script>
import oracle from "@/oracle";

export default {
  name: "Footer",
  data: () => ({
    oracle: oracle,
    socials: []
  }),
  mounted() {
    oracle.axios('social/getList', {"order_by": "priority"}, (res) => {
      this.socials = res.data
    })
  }
};
</script>
<style>
.footer {
  border-top: 5px solid #7ec352;
}

.footer .contact {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 2px solid #666;
  padding-top: 25px;
}

.footer .sign-up {
  display: flex;
  align-self: center;

}

.footer .sign-up .v-text-field.v-text-field--solo .v-input__control,
.footer .sign-up button {
  min-height: 45px !important;
}

.footer .sign-up .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #f0f0f0;
  text-align: left !important;
  padding: 0 15px !important;
  color: #666;
}

.footer .sign-up button {
  min-width: 40px !important;
  color: #333 !important;
  font-size: 13px !important;
}

.footer .sign-up .v-text-field .v-input__slot,
.footer .sign-up button {
  box-shadow: none !important;
  border-radius: 0;
}

.footer .sign-up .v-text-field label {
  font-size: 12px;
}

.footer .sign-up .v-text-field {
  font-size: 14px;
}

.footer .img-social img {
  width: 100px;
  height: auto;
  object-fit: contain;
}

.footer .social {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
}

.footer .item-social {
  display: flex;
  width: fit-content;
}

.footer .item-social .v-icon {
  font-size: 30px !important;
  color: #666 !important;
  margin-right: 15px !important;
  margin-left: 15px !important;
  line-height: 50px !important;
}

.footer .end-footer span {
  font-size: 13px;
  margin: 0 20px;
}

.footer .end-footer {
  margin-top: 15px;
}

/*@media only screen and (max-width: 480px) {*/
/*    .footer .contact {*/
/*        display: block;*/
/*        text-align: center !important;*/
/*    }*/

/*    .footer .end-footer {*/
/*        text-align: center !important;*/
/*    }*/

/*    .footer .sign-up .v-input__slot {*/
/*        width: 200px;*/
/*    }*/
/*}*/
</style>
